import type { DefaultNamespace } from 'i18next'
import type { FC, ReactNode } from 'react'
import { ScrollArea } from '@/components/ui/scroll-area'
import { Scrollbar } from '@/components/ui/scrollbar'
import { Separator } from '@/components/ui/separator'

interface GalleryModalSidebarProps {
	title: string | DefaultNamespace
	content: ReactNode
}

export const GalleryModalSidebar: FC<GalleryModalSidebarProps> = ({
	title,
	content
}) => {
	return (
		<div className='grid w-[336px] grid-cols-[minmax(0,1fr)] grid-rows-[auto_auto_minmax(0,1fr)]'>
			<h3 className='px-6 pt-[68px] pb-5 font-medium text-lg text-neutral-900'>
				{title}
			</h3>

			<Separator orientation='horizontal' />

			<ScrollArea
				scrollbar={<Scrollbar />}
				style={{ overflow: 'hidden' }}
			>
				{content}
			</ScrollArea>
		</div>
	)
}

GalleryModalSidebar.displayName = 'GalleryModalSidebar'
